export default {
  'sendverificationsms.sendverificationsms': '確認コードの申請',
  'sendverificationsms.maintext':
    '[SMSの送信] ボタンをクリックすると、登録された電話に、確認コードが届きます。',
  'sendverificationsms.sendsms': 'SMSを送信してください',
};
